import { render, staticRenderFns } from "./averageClinic.vue?vue&type=template&id=220c2ae3"
import script from "./averageClinic.vue?vue&type=script&lang=js"
export * from "./averageClinic.vue?vue&type=script&lang=js"
import style0 from "./averageClinic.vue?vue&type=style&index=0&id=220c2ae3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports